import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { CONSTANTS } from '../../../dataModels/constants';
import { HelperService } from '../../../services/utils/helper.service';
/**
 * Notes component
 */
@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {
  /**
   * Formgroup
   */
  commentsFrm: UntypedFormGroup;

  /**
   * boolean to indicate if form is submitted and run validations
   */
  submit = false;

  /**
   * mode ADD or UPDATE
   */
  @Input() mode = CONSTANTS.ADD;

  /**
   * formdata for comments
   */
  formData = {
    isError: false,
    data: {
      comments: ''
    }
  };

  /**
   * list of comments
   */
  notesList = [];

  /**
   * notes headers
   */
  noteHeaders = [];

  /**
   * boolean to indicate if form has to be disabled
   */
  @Input() disableForm = false;

  /**
   * constructor to inject dependency
   * @param helperService instance of helperService
   */
  constructor(private helperService: HelperService) {}

  /**
   * initialize component
   */
  ngOnInit(): void {
    this.init();
  }

  /**
   * initialize
   */
  init() {
    this.initFormControls();
    if (this.mode === CONSTANTS.UPDATE) {
      this.f.comments.setValidators([Validators.required]);
    } else {
      this.f.comments.clearValidators();
    }
    this.f.comments.updateValueAndValidity();
  }

  /**
   * initialize form group with controls
   */
  initFormControls() {
    this.commentsFrm = new UntypedFormGroup({
      comments: new UntypedFormControl('')
    });
  }

  /**
   * getter for form controls
   */
  get f() {
    return this.commentsFrm?.controls;
  }

  /**
   * Check if control is invalid
   * @param ctrl ctrl to check invalidity for
   */
  isControlInvalid(ctrl: AbstractControl) {
    return this.helperService.isControlInvalid(this.submit, ctrl);
  }

  /**
   * return the form data
   */
  getFormData() {
    this.submit = true;

    this.formData.isError = !this.commentsFrm.valid;

    if (this.commentsFrm.valid) {
      this.formData.data.comments = this.helperService.encodeJsonString(this.f.comments.value);
    }
    return this.formData;
  }

  /**
   * reset form to its original data
   */
  resetForm() {
    this.submit = false;
    this.helperService.resetForm(this.commentsFrm);
  }

  /**
   * check if component canDeactivate
   */
  canDeactivate() {
    return this.helperService.canDeactivate(this.commentsFrm);
  }

  /**
   * bind notes
   * @param notes notes to show
   * @param notesHeaders note headers
   */
  setNotes(notes, notesHeaders) {
    this.notesList = notes;
    this.noteHeaders = notesHeaders;
  }

  /**
   * disable form
   */
  doDisableForm() {
    if (this.disableForm) {
      this.commentsFrm.disable();
    }
  }
}
